import { apiClient } from '@/api/client';

export interface CompletePasswordResetInput {
  email: string;
  code: string;
  newPassword: string;
  confirmNewPassword: string;
}

/**
 * Request a password reset code (MYN-133 / FR-05b). The backend always
 * responds 202 with an empty body - identically whether the address is
 * registered, unregistered, or refused by the resend cooldown - so this
 * resolves the same way for every address. There is nothing to branch on.
 */
export async function requestPasswordReset(email: string): Promise<void> {
  await apiClient.post('/auth/forgot-password', { email });
}

/**
 * Complete a password reset with the emailed code and new password.
 * Resolves on 200. Rejects with `PASSWORD_CONFIRMATION_MISMATCH` if the two
 * passwords differ, or `OTP_INVALID` for every OTP failure reason (wrong,
 * expired, already used, or never issued - the backend collapses all four).
 */
export async function completePasswordReset(input: CompletePasswordResetInput): Promise<void> {
  await apiClient.post('/auth/reset-password', input);
}
